import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";

interface CoupleSectionProps {
  brideName: string;
  groomName: string;
  onBrideNameChange: (value: string) => void;
  onGroomNameChange: (value: string) => void;
  /** When true (baptism-only event), labels show Mother/Father instead of Bride/Groom */
  isBaptismOnly?: boolean;
}

export function CoupleSection({
  brideName,
  groomName,
  onBrideNameChange,
  onGroomNameChange,
  isBaptismOnly = false,
}: CoupleSectionProps) {
  const { t } = useTranslation();
  const label1 = isBaptismOnly ? t("events.form.mother") : t("events.form.brideName");
  const label2 = isBaptismOnly ? t("events.form.father") : t("events.form.groomName");
  // JUB-95: these are the parents' names, not the baby's — reuse the
  // mother/father labels as placeholders instead of the baby-name copy.
  const placeholder1 = isBaptismOnly ? t("events.form.mother") : t("events.brideNamePlaceholder");
  const placeholder2 = isBaptismOnly ? t("events.form.father") : t("events.groomNamePlaceholder");
  return (
    <div className="space-y-4">
      <Label>{t("events.form.couple")}</Label>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="bride-name">{label1}</Label>
          <Input
            id="bride-name"
            value={brideName}
            onChange={(e) => onBrideNameChange(e.target.value)}
            placeholder={placeholder1}
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="groom-name">{label2}</Label>
          <Input
            id="groom-name"
            value={groomName}
            onChange={(e) => onGroomNameChange(e.target.value)}
            placeholder={placeholder2}
            className="mt-1"
          />
        </div>
      </div>
    </div>
  );
}

